import React from "react";
import { motion } from "framer-motion";
import "./creative.css";

function Creative() {
  return (
    <div>
      <h2 className="creative-heading">Creative Play</h2>
      <motion.div 
        className="container"
        initial={{ x: "-100vw", opacity: 0 }} // Start off-screen
        animate={{ x: 0, opacity: 1 }} // Move to position
        transition={{ duration: 3, ease: "easeOut" }} // Smooth transition
      >
        <p>
          Children learn as they play. Most importantly, in play children learn
          how to learn. ~ O. FRED DONALDSON
        </p>
        <p>
          There are many aspects of creative play that promote learning and
          development in children. It is important for children to express
          themselves in many different ways; creative play is an important part of
          this. Giving a child the freedom to draw or create something by
          themselves will liberate them and give them confidence. When being
          creative it is important to allow the children to explore and develop
          their senses by using different media and materials. The child can then
          explore different elements of creativity.
        </p>
        <p>
          One unique feature of Deepti is the importance given to Creative Play.
          Deepti is aimed at being the centre of excellence in Creative Play, so
          that it can be a model for others to follow. Creative play was first
          introduced at Deepti in March 2011, by Mrs. Caroline Essame, Creative
          Arts Therapist and Director of Create@Centre-Stage from Singapore. Mrs.
          Caroline Essame and Ms. Caroline Molloy, an Occupational Therapist, from
          UK visit Deepti yearly to train children and teachers in Creative Play.
        </p>
        <p>
          Children learn and develop physical, social, emotional and cognitive
          skills through creative play and it is crucial to all children to help
          them understand and interact with the world around and within them.
        </p>
        <p>
          Creative play is innovative and fun. Children use large brushes, for
          painting, encouraging large arm and hand movements, which are a
          prerequisite to finer movement required for feeding, and other selective
          tasks. Traditional sand play trays are replaced with local rice and
          spices to create tactile and sensory stimulation. The children also
          explore and enjoy projective and imaginative play with puppets, play
          food and cutlery and simple dressing up and face paints. Music, movement
          and songs are also used throughout the sessions giving rhythm, form and
          group interactions to the sessions.
        </p>
        <p>
          Throughout the years, various experts from abroad have visited Deepti to
          train children and staff in creative play, conducting workshops and
          seminars for parents.
        </p>
      </motion.div>
    </div>
  );
}

export default Creative;
